module.exports = __webpack_public_path__ + "/static/assets/1bf1dcc5a4b0a53a46d16e23fdb315a6.png";